export const ADMIN = {
  page: 'admin-page',
  backBtn: 'admin-back-btn',
  categoryTab: 'admin-category-tab',
  uploadTitle: 'admin-upload-title-input',
  uploadFile: 'admin-upload-file-input',
  uploadText: 'admin-upload-text-input',
  uploadSubmit: 'admin-upload-submit-btn',
  documentRow: 'admin-document-row',
  deleteDocBtn: 'admin-delete-doc-btn',
};
